<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_25"></a><a id="part01chapter06"></a>CHAPTER 6</h3>
<p class="image1"><img alt="Image" src="images/line1.gif"/></p>
<p class="linespace"> </p>
<p class="para">Finding God would be difficult, but finding lunch was easy. I left Vital Records, past the customers, smokers, and staff, who traded resigned looks as they realized the alarm had ended with no fire trucks in sight. I put the same quarter in the same meter and got it back. I was starting to like it here. Down the street a meter maid ticketed a car. She glared at me. I flipped the quarter and caught it, George Raft-style, then leered at her.</p>
<p class="indent-para">My stomach growled in anticipation. I crossed Maine Avenue and bellied up to the counter of Custis and Brown’s, where I slammed down two bowls of Maryland she-crab chowder, then placed a call to Lieutenant Emil Haggler, a D.C. homicide cop I knew. A male voice answered second district. I asked for Haggler, was put on hold, then a voice came over the phone and said, “Haggler.”</p>
<p class="indent-para">“It’s Willis.”</p>
<p class="indent-para">“Well, well. Where you been, son?”</p>
<p class="indent-para">“Here and there. I wonder could you do me a favor?”</p>
<p class="indent-para">“No more parkin’ tickets, Willis, I done told you before.”</p>
<p class="indent-para">“This is different. I’m trying to find someone for a friend of mine and I wonder could you help me?”</p>
<p class="indent-para">“Oh, yeah, the part-time <em>de</em>tective,” he said. “Somebody late on their alimony?”</p>
<p class="indent-para">“No, missing person, and it’s the first case I’ve had this year that doesn’t involve infrared video and telephoto lenses.”</p>
<p class="indent-para">“Glad to hear it. I can think of another cop who’d approve.”</p>
<p class="indent-para"><a id="page_26"></a>He was talking about Captain Shadrack Davies, who had been Emil’s boss and one of my foster fathers. This was my cue to say something about Shad. Instead, I kept on target. “Right. So how about a search on Jackson, Bobbie?”</p>
<p class="indent-para">“Man or woman?”</p>
<p class="indent-para">“Woman, African American, about twenty to twenty-five years old.”</p>
<p class="indent-para">“Where you looked so far?”</p>
<p class="indent-para">“Just a request at Vital Records.”</p>
<p class="indent-para">“Okay. I could check our files, see she has a criminal record.”</p>
<p class="indent-para">“Good. Could you also check DMV?”</p>
<p class="indent-para">I could hear him scribbling away. “Anything else?”</p>
<p class="indent-para">“Phone and utilities. Oh, and bank accounts.”</p>
<p class="indent-para">“Christ, you want me to wipe your ass for you, too?”</p>
<p class="indent-para">“No, I’m doing pretty good with that now.”</p>
<p class="indent-para">“Could have fooled me.” Then he hung up.</p>
<p class="indent-para">I was lucky I’d caught him on a good day.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01chapter06.vue?43cf65a0